module.exports = __webpack_public_path__ + "static/media/pic4_trial.f3c3870f.png";